
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 3c1.645 0 3 1.355 3 3s-1.355 3-3 3-3-1.355-3-3 1.355-3 3-3zm0 2c-.564 0-1 .436-1 1s.436 1 1 1 1-.436 1-1-.436-1-1-1zm-5.469 2.781c.404-.046.828.057 1.188.25V8l1.688.938a3 3 0 011.406 3.656l-1.156 3.219a7.023 7.023 0 011.656 2.188h1.875c.934 0 1.77.648 1.969 1.563l1.313 6.094-1.938.438-1.344-6.094h-1.281c.047.327.094.66.094 1 0 3.854-3.146 7-7 7s-7-3.146-7-7c0-3.514 2.617-6.417 6-6.906L13.47 9.94l-2.281.25-2.5 3.844-1.688-1.063 2.5-3.875a1.978 1.978 0 011.438-.906zm1 2.407l-1.438 3.906a6.948 6.948 0 011.844.563l1-2.75a.986.986 0 00-.469-1.219zM13 16c-2.773 0-5 2.227-5 5s2.227 5 5 5 5-2.227 5-5-2.227-5-5-5z"}})])
          )
        }
      }
    